import BasicReadField from '../BasicReadField';
import SparqlProjectCard from './SparqlProjectCard';
import AreYouSure from '../../core/AreYouSure';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import PrimaryButton from '../PrimaryButton';
import SecondaryButton from '../SecondaryButton';
import LabelledSwitch from '../LabelledSwitch';
import LangConfirmationField from '../LangConfirmationField';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from '../style/gstheme';
import TitledPanel from '../TitledPanel';
import withGS from '../withGShoc';
import { MAX_DESCRIPTION_LENGTH, MAX_TITLE_LENGTH } from '../utils/constants';
import { getGraphFromProject } from '../utils/utils';

class QueryDetail extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            areYouSure: false
        };
    }

    checkIfSure = () => this.setState({ areYouSure: true })

    onNotSure = () => this.setState({ areYouSure: false })

    onSure = () => {
        this.setState({ areYouSure: false });
        this.props.onDeleteQuery(this.props.id);
    };

    onUpdate = (property) => (value) => {
        const lang = this.props.defaultLang;
        const exists = this.props.data[property] && this.props.data[property][lang];
        if (!exists) {
            this.props.onAdd(property, value, lang);
        }
        else this.props.onUpdate(property, value, lang, 0);
    };

    onDelete = (property) => (value) => this.props.onDelete(property, value, this.props.defaultLang);

    handleReportChange = (useXL) => {
        this.props.data.isReport !== undefined ?
            this.props.onUpdate('isReport', useXL.toString())
            :
            this.props.onAdd('isReport', true.toString());
    };

    render() {

        const { classes, data, onRevertQuery, isNotDirty, disabled, defaultLang, updateQuery, reportOption } = this.props;
        const { areYouSure } = this.state;
        const { title, description, isReport, id, query, queryType, queryProject } = data;

        // Can't change query type
        const isReadOnly = this.props.isReadOnly || this.props.queryType !== queryType;

        return (
            <div>
                <TitledPanel dataTest="query-title-panel" title="Title">
                    <LangConfirmationField
                        dataTest="query-title"
                        onUpdate={this.onUpdate("title")}
                        focus={false}
                        canBeDeleted={false}
                        maxLength={MAX_TITLE_LENGTH}
                        multiline={false}
                        text={title[defaultLang]}
                        lang={defaultLang}
                        isReadOnly={isReadOnly} />
                </TitledPanel>
                <TitledPanel dataTest="query-description-panel" margin title="Description">
                    <LangConfirmationField
                        dataTest="query-description"
                        onUpdate={this.onUpdate("description")}
                        onDelete={this.onDelete("description")}
                        focus={false}
                        canBeDeleted={true}
                        maxLength={MAX_DESCRIPTION_LENGTH}
                        multiline={true}
                        allowEmpty={true}
                        text={description && description[defaultLang] ? description[defaultLang] : ""}
                        lang={defaultLang}
                        isReadOnly={isReadOnly} />
                </TitledPanel>
                <TitledPanel dataTest="query-iri-panel" margin title="IRI">
                    <BasicReadField dataTest="iri" fullWidth text={data.id} />
                </TitledPanel>
                {queryProject && queryProject.length > 0 &&
                    <TitledPanel dataTest="additional-saved-projects" margin title="Additional Projects">
                        {[...queryProject].sort().map(ap =>
                            <SparqlProjectCard
                                key={ap}
                                compact={true}
                                handleNotAvailable={true}
                                id={ap}
                                graph={getGraphFromProject(ap)} />
                        )}
                    </TitledPanel>
                }
                {reportOption && queryType === "SELECT" &&
                    <TitledPanel margin title="Options">
                        <LabelledSwitch
                            dataTest="options"
                            checked={isReport}
                            isReadOnly={isReadOnly}
                            disabled={isReadOnly}
                            handleChange={this.handleReportChange}
                            label="Use as a Report" />
                    </TitledPanel>
                }
                <div style={{ marginTop: 12, display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <div style={{ marginRight: 12 }}>
                        <PrimaryButton dataTest='update-query' disabled={isNotDirty || disabled || isReadOnly} onClick={() => updateQuery(id)}>Update</PrimaryButton>
                    </div>
                    <div>
                        <SecondaryButton dataTest='reset-query' disabled={isNotDirty} onClick={() => onRevertQuery(query, queryProject)}>Reset</SecondaryButton>
                    </div>
                    <div style={{ paddingTop: 6 }}>
                        {!this.props.isReadOnly &&
                            <Tooltip placement="right" title='Delete this query'>
                                <IconButton
                                    data-test="delete-saved-query"
                                    size="small"
                                    onClick={this.checkIfSure}
                                    className={classes.deleteButton}>
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>
                        }
                    </div>
                </div>
                {areYouSure && <AreYouSure
                    onSure={this.onSure}
                    onNotSure={this.onNotSure}
                    message={[
                        "Do you really want to delete this query?"
                    ]} />
                }
            </div>
        );
    }
}

QueryDetail.defaultProps = {
    isReadOnly: true,
    reportOption: false
};

QueryDetail.propTypes = {
    data: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    defaultLang: PropTypes.string.isRequired,
    isNotDirty: PropTypes.bool,
    disabled: PropTypes.bool,
    queryType: PropTypes.string,
    graph: PropTypes.string.isRequired,
    isReadOnly: PropTypes.bool,
    onRevertQuery: PropTypes.func.isRequired,
    onAdd: PropTypes.func,
    onUpdate: PropTypes.func,
    onDeleteQuery: PropTypes.func,
    onDelete: PropTypes.func,
    updateQuery: PropTypes.func.isRequired,
    reportOption: PropTypes.bool,
    classes: PropTypes.object
};

export default withStyles(styles)(withGS(QueryDetail));